import { useState } from 'react';

import { ModalBase } from './ModalBase';

import type React from 'react';

const DAY_OPTIONS = [
  { value: 1, label: '+ 1 dia' },
  { value: 2, label: '+ 2 dias' },
  { value: 3, label: '+ 3 dias' },
  { value: 5, label: '+ 5 dias' },
  { value: 7, label: '+ 1 semana' },
];

export function BulkPostponeModal({
  open,
  count,
  submitting,
  onClose,
  onConfirm,
}: {
  open: boolean;
  count: number;
  submitting: boolean;
  onClose: () => void;
  onConfirm: (p: { days: number; reason: string }) => void;
}): React.JSX.Element | null {
  const [days, setDays] = useState(2);
  const [reason, setReason] = useState('');
  if (!open) return null;
  const disabled = submitting || reason.trim().length < 20;
  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title={`Adiar ${count.toString()} pendência${count === 1 ? '' : 's'} em massa`}
      width={520}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button type="button" className="btn-ghost-mini" onClick={onClose}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn-ghost-mini btn-ghost-mini--primary"
            disabled={disabled}
            onClick={() => {
              onConfirm({ days, reason });
            }}
          >
            {submitting ? 'Adiando…' : 'Confirmar adiamento'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <div className="modal-form__callout">
          <b>{count}</b> pendências selecionadas.
        </div>
        <label className="modal-form__field">
          <span className="modal-form__label">Novo prazo</span>
          <select
            className="modal-form__select"
            value={days}
            onChange={(e) => {
              setDays(parseInt(e.target.value, 10));
            }}
          >
            {DAY_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
        <label className="modal-form__field">
          <span className="modal-form__label">Motivo (obrigatório · mínimo 20 caracteres)</span>
          <textarea
            className="modal-form__textarea"
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
            }}
            rows={3}
            placeholder="Fornecedor externo não responde. Adiando pendências dependentes até resolução."
          />
        </label>
        <div className="modal-form__callout modal-form__callout--warn">
          ⚠ Cada pendência tem contagem própria de adiamentos (máx 3 em Team-Pro · ilimitado em
          Regulated). Algumas podem atingir o limite — o sistema lista as que ficarem bloqueadas.
        </div>
      </div>
    </ModalBase>
  );
}
